// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cPrW","question":"styles_question__y-Q7f","inputVisibleButton":"styles_inputVisibleButton__1klFC","note":"styles_note__3vKY3"};